export default {
  quoteAgreement: {},
}
